import React from "react";
import { useTranslation } from "react-i18next";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { useWizard } from "react-use-wizard";
import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { use } from "react";
import { useEffect } from "react";

const IntroMessageStep = (isFirstWizardStep) => {
  const { previousStep, nextStep, goToStep } = useWizard();

  const location = useLocation();
  const isSkipIntroMessage = new URLSearchParams(location.search).get(
    "skipIntroMessage"
  );

  const { t } = useTranslation();

  const history = useHistory();

  const handleSubmit = () => {
    nextStep();
  };

  const handleBack = () => {
    if (isFirstWizardStep) {
      history.goBack(); // or history.push('/your-route') to go to a specific path
    } else {
      previousStep();
    }
  };
  useEffect(() => {
    if (isSkipIntroMessage === "true") {
      nextStep();
    }
  }, []);

  return (
    <>
      <NavigateBackWizardStep
        clickHandler={handleBack}
        title={t("title")}
        hideLibrary={true}
      />
      <div className="body_content">
        <div className="inner_body  d-flex justify-content-center align-items-center m-auto fs-4">
          <span className="fw-bold text-center d-block mb-3">
            We need you to answer a few more questions.
          </span>
        </div>
        <div className="btn_block bottom_button d-flex justify-content-center">
          <button
            className="btn btn_primary nextstep_cta"
            // disabled={selectedChoice?.value == null}
            onClick={() => handleSubmit()}
          >
            {t("login.DOBSTEP.button")}
          </button>
        </div>
      </div>
    </>
  );
};

export default IntroMessageStep;
